import { httpRequest } from "@services/http";
import { ApprovedUrl } from "@models/approvedUrl.model";

export interface UpdateApprovedUrlPayload {
  url?: string;
  title?: string;
  description?: string | null;
  is_active?: boolean;
  /** Send only to move the row. The caller must hold edit on the destination too. */
  organization_id?: number;
}

export class CommandUpdateApprovedUrl {
  async run(organizationId: number, approvedUrlId: number,
            payload: UpdateApprovedUrlPayload): Promise<ApprovedUrl> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/approved-urls/${approvedUrlId}/`;
    const response = await httpRequest<any>(url, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
    return ApprovedUrl.fromJson(response);
  }
}
